import { render, staticRenderFns } from "./DetailPromtion.vue?vue&type=template&id=3575d28e&scoped=true&"
import script from "./DetailPromtion.vue?vue&type=script&lang=js&"
export * from "./DetailPromtion.vue?vue&type=script&lang=js&"
import style0 from "./DetailPromtion.vue?vue&type=style&index=0&id=3575d28e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3575d28e",
  null
  
)

export default component.exports